import { mergeStyleSets, NeutralColors, Depths, DefaultPalette } from '@fluentui/react';

function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
var itemClassNames = {
    container: 'suggestion-container',
    removeHistory: 'suggesiton-remove-history'
};
var styles = mergeStyleSets({
    container: [
        itemClassNames.container,
        _define_property({
            position: 'relative'
        }, "&:hover .".concat(itemClassNames.removeHistory), {
            visibility: 'visible'
        })
    ],
    suggestionIcon: {
        fontSize: 16,
        marginRight: 8,
        color: NeutralColors.gray120
    },
    offerIcon: {
        width: 16,
        height: 16,
        marginRight: 8,
        marginTop: 10,
        alignSelf: 'start'
    },
    historyButton: [
        itemClassNames.removeHistory,
        {
            visibility: 'hidden',
            position: 'absolute',
            top: 0,
            right: 0
        }
    ],
    visible: {
        visibility: 'visible'
    },
    historyIcon: {
        fontSize: 16,
        width: 16,
        height: 16,
        color: DefaultPalette.neutralSecondary
    },
    productType: {
        color: NeutralColors.gray130,
        margin: 0
    },
    integratedWithCard: {
        padding: '6px 8px',
        boxShadow: Depths.depth4
    },
    integratedWithText: {
        color: NeutralColors.gray130,
        marginRight: 8
    },
    integrationIcon: {
        width: 16,
        height: 16,
        ':not(:last-child)': {
            marginRight: 8
        }
    }
});
var listButton = {
    root: {
        width: '100%',
        minHeight: 36,
        display: 'flex',
        justifyContent: 'start',
        alignItems: 'center',
        padding: 8
    }
};

export { listButton, styles };
